module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_pepita_amarilla_tostada.071543d1.pdf";